module.exports = __webpack_public_path__ + "static/media/pilotly-white-symbol.4d81d361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/pilotly-white-symbol.png
// module id = 590
// module chunks = 0